<script>

  import {API_EMPLOYEE} from '../../common/api'
  import EmployeeCommon from './EmployeeCommon'

  export default {
    name: 'EmployeeUpdate',
    props: ["admin_id"],
    extends: EmployeeCommon,
    created() {
      this.getEmployee()
    },
    methods: {
      // 员工单条
      getEmployee() {
        this.isLoading = true;
        this.$http.GET(API_EMPLOYEE + '/' + this.admin_id, null,
          res => {
            this.employeeForm = {
              name: res.result.data.name,
              mobile: res.result.data.mobile,
              password: '******',
              role_id: res.result.data.role_id
            };
            this.isLoading = false
          }, err => {
            this.$message.error(err.msg);
            this.isLoading = false
          })
      },
      // 修改
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            let params = this.employeeForm;
            this.$http.PUT(API_EMPLOYEE + '/' + this.admin_id, params,
              res => {
                this.loading = false;
                this.$emit('updateEmployeeSuccess')
              }, err => {
                this.loading = false;
                this.$message.error(err.msg)
              })
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
    components: {
      EmployeeCommon
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/employee/EmployeeUpdate.vue